import { useTranslations } from '@vocab/react';
import { Stack } from 'braid-design-system';
import { useCallback } from 'react';

import translations from '../.vocab';
import RefreshRecommendationsButton from '../RefreshRecommendationsButton';
import { useGetResetCandidateChatContext } from '../hooks/candidateChatContextHelpers';
import { useCareerFeedAIAssistant } from '../hooks/useCareerFeedAIAssistant';

import { TextSection } from './TextSection';

export const RecommendationRefinedConfirmation = () => {
  const resetPreferences = useGetResetCandidateChatContext();
  const {
    tracking: { trackGenAIChatResetPressed },
  } = useCareerFeedAIAssistant();
  const { t } = useTranslations(translations);

  const onReset = useCallback(() => {
    trackGenAIChatResetPressed('chat widget');
    resetPreferences();
  }, [resetPreferences, trackGenAIChatResetPressed]);

  return (
    <Stack space="small">
      <TextSection>
        {t(
          "We've updated your recommendations based on your answers. Take a look at the personalised job listings.",
        )}
      </TextSection>
      <RefreshRecommendationsButton onReset={onReset} />
    </Stack>
  );
};
